/**
 * Set Password page initialization
 */

async function loadUserInfo(): Promise<void> {
  try {
    const response = await fetch("/api/auth/me");
    if (!response.ok) {
      window.location.href = "/login";
      return;
    }

    const backLinkContainer = document.getElementById("backLinkContainer");
    if (backLinkContainer) {
      backLinkContainer.innerHTML = `<a href="/account" class="back-link">\u2190 Back to Account</a>`;
    }
  } catch (error) {
    console.error("Failed to load user info:", error);
    window.location.href = "/login";
  }
}

function clearErrors(): void {
  const errorFields = ["passwordError", "confirmPasswordError", "generalError"];
  errorFields.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.textContent = "";
  });
}

function showError(fieldId: string, message: string): void {
  const errorElement = document.getElementById(fieldId);
  if (errorElement) {
    errorElement.textContent = message;
  }
}

function validateForm(password: string, confirmPassword: string): boolean {
  clearErrors();

  if (password !== confirmPassword) {
    showError("confirmPasswordError", "Passwords do not match");
    return false;
  }

  if (password.length < 8) {
    showError("passwordError", "Password must be at least 8 characters");
    return false;
  }

  return true;
}

async function handleSubmit(e: Event): Promise<void> {
  e.preventDefault();
  clearErrors();

  const passwordInput = document.getElementById(
    "password"
  ) as HTMLInputElement | null;
  const confirmPasswordInput = document.getElementById(
    "confirmPassword"
  ) as HTMLInputElement | null;

  if (!passwordInput || !confirmPasswordInput) return;

  const password = passwordInput.value;
  const confirmPassword = confirmPasswordInput.value;

  if (!validateForm(password, confirmPassword)) {
    return;
  }

  try {
    const response = await fetch("/api/auth/set-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password, confirm_password: confirmPassword }),
    });

    const result = (await response.json()) as { error?: string };

    if (response.ok) {
      window.location.href = "/account";
    } else {
      showError("generalError", result.error || "Failed to set password");
    }
  } catch (err) {
    console.error("Failed to set password:", err);
    showError("generalError", "Failed to set password. Please try again.");
  }
}

function setupForm(): void {
  const form = document.getElementById(
    "setPasswordForm"
  ) as HTMLFormElement | null;
  if (form) {
    form.addEventListener("submit", handleSubmit);
  }
}

export function initSetPassword(): void {
  loadUserInfo();
  setupForm();
}
